import {
    DELETE_CUSTOMER_FAILED,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_LOADING,
    } from "../types";
    
    const initialState = {
      loading: false,
      error: null,
      status: null,
      message:null ,
    };
    
    export const DeleteCustomerReducer = (
      state = initialState,
      action: { type: any; loading:boolean , payload: any, error: any, status: string , message : string  }
    ) => {
      switch (action.type) {
        case DELETE_CUSTOMER_LOADING:
          return {
            ...state,
            loading: action.loading,
          };
        case DELETE_CUSTOMER_SUCCESS:
         //
          return {
            ...state,
            loading: false,
            status: action.payload,
            message:action.payload ,
            error: null,
          };
        case DELETE_CUSTOMER_FAILED:
          return {
            ...state,
            loading: false,
            status: null,
            message:null , 
            error: action.error,
          };
          
        default:
          return state;
      }
    };
    